<template>
	<div>
		<div class="infomation" id="infomation" style="height:309px">
			<ul class="infomation-menu">
				<li :class="{'active': clientType == 1}" data-type="1" @click="changeClientType">基本信息</li>
				<li :class="{'active': clientType == 2}" data-type="2" @click="changeClientType">身份信息</li>
				<li :class="{'active': clientType == 3}" data-type="3" @click="changeClientType">房产信息</li>
				<li :class="{'active': clientType == 4}" data-type="4" @click="changeClientType">车产信息</li>
				<li :class="{'active': clientType == 5}" data-type="5" @click="changeClientType">保单信息</li>
				<li :class="{'active': clientType == 6}" data-type="6" @click="changeClientType">信用信息</li>
				<li :class="{'active': clientType == 8}" data-type="8" @click="changeClientType">需求信息</li>
				<li :class="{'active': clientType == 9}" data-type="9" @click="changeClientType">全部信息</li>
			</ul>
			<div class="infomation-info" v-if="clientType == 1">
				<h1 class="infomation-info-top">基本信息<span>BASIC INFORMATION</span></h1>
				<table class="infomation-info-main">
					<tr>
						<td class="attribute"><span class="starcolor">* </span>姓名：</td>
						<td class="attribute-content"><Input disabled style="width: 170px;color: #000FFF;"
								v-model="client.name" /></td>
						<td class="attribute"><span class="starcolor">* </span>手机号码：</td>
						<td class="attribute-content"><span>{{client.phone}}</span><span @click="callMobile">
								<Icon type="ios-call" size="30" color="#67C239" />
							</span></td>
					</tr>
					<tr>
						<td class="attribute"><span class="starcolor">* </span>来源：</td>
						<td class="attribute-content">
							<Input v-model="client.source" disabled style="width: 170px" />
						</td>
						<td class="attribute"><span class="starcolor">* </span>申请城市：</td>
						<td class="attribute-content">
							<Input v-model="client.city" style="width: 170px" />
						</td>
					</tr>
					<tr>
						<td class="attribute">年龄：</td>
						<td class="attribute-content"><Input v-model="client.age" style="width: 170px" />&nbsp;岁</td>
						<td class="attribute">性别：</td>
						<td class="attribute-content">
							<RadioGroup v-model="client.sex">
								<Radio :label="1"><span>男</span></Radio>
								<Radio :label="2"><span>女</span></Radio>
							</RadioGroup>
						</td>
					</tr>
					<tr>
						<td class="attribute">婚姻：</td>
						<td class="attribute-content">
							<Select v-model="client.maritalStatus" :transfer=true style="width:170px">
								<Option v-for="item in maritalList" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</td>
						<td class="attribute">学历：</td>
						<td class="attribute-content">
						</td>
					</tr>
					<tr>
						<td class="attribute">毕业院校（完整名称）：</td>
						<td class="attribute-content"><Input v-model="client.school" style="width: 170px" /></td>
						<td class="attribute">客户公司：</td>
						<td class="attribute-content"><Input v-model="client.company" style="width: 170px" /></td>
					</tr>
					<tr>
						<td class="attribute">申请额度：</td>
						<td class="attribute-content"><Input v-model="client.loans_money" style="width: 170px;" /></td>
						<td class="attribute">是否本地人：</td>
						<td class="attribute-content">
							<Select v-model="client.is_local_region" :transfer=true style="width:170px">
								<Option v-for="item in isLocalRegionList" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</td>
					</tr>
					<tr>
						<td class="attribute">客户基本信息备注：</td>
						<td class="attribute-content"><Input type="textarea" v-model="client.remark"
								style="width: 170px;" /></td>
					</tr>
				</table>
				<div class="infomation-info-foot"><input value="保存" @click="saveClient"></div>
			</div>
			<!-- 身份信息 -->
			<div class="infomation-info" v-if="clientType == 2">
				<h1 class="infomation-info-top">身份信息<span>IDENTITY INFORMATION</span></h1>
				<table class="infomation-info-main">
					<tr>
						<td class="attribute">客户类型：</td>
						<td class="attribute-content">
							<Select :transfer=true v-model="client.type" style="width: 170px">
								<Option value="1">个人客户</Option>
								<Option value="2">企业客户</Option>
							</Select>
						</td>
					</tr>
					<!-- 工薪族 -->
					<tr class="jobinfo1">
						<td class="attribute">公积金：</td>
						<td class="attribute-content">
							<Select :transfer=true v-model="client.is_accumulation" style="width:170px">
								<Option v-for="item in is_accumulation_list" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</td>
						<td class="attribute">社保：</td>
						<td class="attribute-content">
							<Select :transfer=true v-model="client.is_social_security" style="width:170px">
								<Option v-for="item in is_social_security_list" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</td>
					</tr>
					<!-- 工薪族 -->
					<tr class="jobinfo1" v-if="client.type == 1">
						<td class="attribute">工资发放方式：</td>
						<td class="attribute-content">
							<Select :transfer=true v-model="client.income_type" style="width:170px">
								<Option v-for="item in income_type_list" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</td>
						<td class="attribute">月收入：</td>
						<td class="attribute-content">
							<Input v-model="client.income_sum" style="width: 170px;" /> &nbsp;元
						</td>
					</tr>
					<tr class="jobinfo1" v-if="client.type == 1">
						<td class="attribute">工资连续发放时长：</td>
						<td class="attribute-content"><Input v-model="client.work_income_long"
								style="width: 170px;" />&nbsp;月</td>
						<td class="attribute">个人+公司公积金缴存额：</td>
						<td class="attribute-content"><Input v-model="client.work_gongjijin_jiaocunmoney"
								style="width: 170px;" />&nbsp;元</td>
					</tr>
					<tr class="jobinfo1" v-if="client.type == 1">
						<td class="attribute">公积金缴存基数：</td>
						<td class="attribute-content"><Input v-model="client.accumulation_fund_cardinal_number"
								style="width: 170px;" />&nbsp;元</td>
						<td class="attribute">公积金缴存时长：</td>
						<td class="attribute-content"><Input v-model="client.accumulation_fund_buy_time"
								style="width: 170px;" />&nbsp;月</td>
					</tr>
					<tr class="jobinfo1" v-if="client.type == 1">
						<td class="attribute">社保缴存基数：</td>
						<td class="attribute-content"><Input v-model="client.social_security_cardinal_number"
								style="width: 170px;" />&nbsp;元</td>
						<td class="attribute">社保缴存时长：</td>
						<td class="attribute-content"><Input v-model="client.social_security_buy_time"
								style="width: 170px;" />&nbsp;月</td>
					</tr>
					<!-- 企业主 -->
					<tr class="jobinfo2" v-if="client.type == 2">
						<td class="attribute">有无营业执照：</td>
						<td class="attribute-content">
							<Select :transfer=true v-model="client.is_business_license" style="width:170px">
								<Option v-for="item in bussine_license" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</td>
						<td class="attribute">经营年限：</td>
						<td class="attribute-content">
							<Select :transfer=true v-model="client.business_years" style="width: 170px">
								<Option value="1">1年以下</Option>
								<Option value="2">1~2年</Option>
								<Option value="3">2年以上</Option>
							</Select>&nbsp;年
						</td>
					</tr>
					<tr class="jobinfo2" v-if="client.type == 2">
						<td class="attribute">占股比例：</td>
						<td class="attribute-content"><Input v-model="client.business_gufen" style="width: 170px;" />%
						</td>
					</tr>
					<!-- 企业税贷-->
					<tr class="jobinfo3" v-if="client.type == 2">
						<td class="attribute">信用评级：</td>
						<td class="attribute-content">
							<Select :transfer=true v-model="client.credit_rate" style="width: 170px">
								<Option value="A">A级</Option>
								<Option value="B">B级</Option>
								<Option value="C">C级</Option>
								<Option value="D">D级</Option>
								<Option value="M">M级</Option>
							</Select>
						</td>
						<td class="attribute">经营年限：</td>
						<td class="attribute-content">
							<Select :transfer=true v-model="client.business_years" style="width: 170px">
								<Option value="1">1年以下</Option>
								<Option value="2">1~2年</Option>
								<Option value="3">2年以上</Option>
							</Select>&nbsp;年
						</td>
					</tr>
				</table>
				<div class="infomation-info-foot"><input value="保存" @click="saveClient">
				</div>
			</div>
			<!-- 房产信息 -->
			<div class="infomation-info" v-if="clientType == 3">
				<h1 class="infomation-info-top">房产信息<span>REAL ESTATE INFORMATION</span></h1>
				<table class="infomation-info-main">
					<tr>
						<td class="attribute">名下房产情况：</td>
						<td class="attribute-content">
							<Select :transfer=true v-model="client.is_house" style="width:170px">
								<Option v-for="item in houseItems" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</td>
						<td class="attribute"><span class=" houseinfo2 houseinfo3">房产类型：</span></td>
						<td class="attribute-content houseinfo2 houseinfo3">
							<Select :transfer=true v-model="client.house_type" style="width:170px">
								<Option v-for="item in houseTypeList" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</td>
					</tr>
					<tr>
						<td class="attribute">
							<span class="houseinfo2 houseinfo3">房产所在地：</span>
						</td>
						<td class="attribute-content houseinfo2 houseinfo3">
							<Input v-model="client.house_location" style="width: 170px;" />
						</td>
						<td class="attribute houseinfo2"><span class="houseinfo">房产现价：</span></td>
						<td class="attribute-content houseinfo2"><Input v-model="client.houseSum"
								style="width: 170px;" />&nbsp;万</td>
					</tr>
					<tr class="houseinfo2">
						<td class="attribute houseinfo2 houseinfo3"><span class="houseinfo">房产面积：</span></td>
						<td class="attribute-content houseinfo2 houseinfo3"><Input v-model="client.house_area"
								style="width: 170px;" />&nbsp;平方米</td>

						<td class="attribute">房产证持有时间：</td>
						<td class="attribute-content">
							<Input v-model="client.house_buy_time" style="width: 170px;" />&nbsp;月
						</td>
					</tr>
					<tr class="houseinfo2 houseinfo3">
						<td class="attribute houseinfo2 houseinfo3">房产状态：</td>
						<td class="attribute-content houseinfo2 houseinfo3">
							<Select :transfer=true v-model="client.house_status" style="width:170px">
								<Option v-for="item in houseStatusList" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</td>
						<td class="attribute house_status">月供时间：</td>
						<td class="attribute-content house_status">
							<Input v-model="client.monthlyPeriod" style="width: 170px;" />&nbsp;月
						</td>
					</tr>
					<tr class="houseinfo2">
						<td class="attribute"><span class="houseinfo house_status">月供金额：</span></td>
						<td class="attribute-content house_status"><Input v-model="client.monthlySum"
								style="width: 170px;" />&nbsp;元</td>
					</tr>
				</table>
				<div class="infomation-info-foot"><input value="保存" @click="saveClient">
				</div>
			</div>
			<!-- 车产信息 -->
			<div class="infomation-info" v-if="clientType == 4">
				<h1 class="infomation-info-top">车产信息<span>VEHICLE PRODUCTION INFORMATION</span></h1>
				<table class="infomation-info-main">
					<tr>
						<td class="attribute">名下车产情况：</td>
						<td class="attribute-content">
							<Select :transfer=true v-model="client.is_car" style="width:170px">
								<Option v-for="item in carItems" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>

						</td>
						<td class="attribute"><span class="carinfo2">汽车类型：</span></td>
						<td class="attribute-content">
							<Select :transfer=true v-model="client.car_type" style="width:170px">
								<Option v-for="item in carTypeList" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</td>
					</tr>
					<tr class="carinfo2">
						<td class="attribute">车牌归属地：</td>
						<td class="attribute-content"><Input v-model="client.car_location" style="width: 170px;"
								placeholder="车牌归属地" /></td>
						<td class="attribute">车辆估价(万)：</td>
						<td class="attribute-content"><Input v-model="client.car_valuation_money" style="width: 170px;"
								placeholder="车辆估价" /></td>
					</tr>
					<tr class="carinfo2">
						<td class="attribute">使用年限：</td>
						<td class="attribute-content">
							<Input v-model="client.car_years" style="width: 170px;" placeholder="使用年限" />
						</td>
						<td class="attribute">保险公司：</td>
						<td class="attribute-content"><Input v-model="client.car_insurance_company"
								style="width: 170px;" placeholder="保险公司" /></td>
					</tr>

					<tr class="carinfo2">
						<td class="attribute">当前保单缴费次数：</td>
						<td class="attribute-content"><Input v-model="client.car_baodan_paynum" style="width: 170px;"
								placeholder="当前保单缴费次数" /></td>
						<td class="attribute">车辆状态：</td>
						<td class="attribute-content">
							<Select :transfer=true v-model="client.car_mortgage_status" style="width:170px">
								<Option v-for="item in carStatusList" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</td>
					</tr>
					<tr class="carinfo2">
						<td class="attribute">月供时间(月)：</td>
						<td class="attribute-content"><Input v-model="client.car_repayment_month" style="width: 170px;"
								placeholder="月供时间" /></td>
						<td class="attribute">月还款额(万)：</td>
						<td class="attribute-content"><Input v-model="client.car_mortgage_money" style="width: 170px;"
								placeholder="月还款额" /></td>
					</tr>

				</table>
				<div class="infomation-info-foot"><input value="保存" @click="saveClient">
				</div>
			</div>
			<!-- 保单信息 -->
			<div class="infomation-info" v-if="clientType == 5">
				<h1 class="infomation-info-top">保单信息<span>POLICY INFORMATION</span></h1>
				<table class="infomation-info-main">
					<tr>
						<td class="attribute">有无保单：</td>
						<td class="attribute-content">
							<Select :transfer=true v-model="client.policyShow" style="width:170px">
								<Option v-for="item in policyShowList" :value="item.value" :key="item.value">
									{{ item.label }}
								</Option>
							</Select>
						</td>
						<td class="attribute"><span class="havepolicy">保险公司：</span></td>
						<td class="attribute-content">
							<Input v-model="client.payment_company" style="width: 170px;" placeholder="保险公司" />
						</td>
					</tr>
					<tr class="havepolicy">
						<td class="attribute">年缴额(元)：</td>
						<td class="attribute-content"><Input v-model="client.policy_pay_money" style="width: 170px;"
								placeholder="年缴额" /></td>
						<td class="attribute">已缴次数：</td>
						<td class="attribute-content"><Input v-model="client.policy_buy_time" style="width: 170px;"
								placeholder="已缴次数" /></td>
					</tr>
				</table>
				<div class="infomation-info-foot"><input value="保存" @click="saveClient">
				</div>
			</div>
			<!-- 信用信息 -->
			<div class="infomation-info" v-if="clientType == 6">
				<table class="infomation-info-main">
					<tr>
						<td class="attribute">2个月内查询次数：</td>
						<td class="attribute-content">
							<Input v-model="client.credit_check_twomonth_num" style="width: 170px;"
								placeholder="2个月内查询次数" />&nbsp;次
						</td>
						<td class="attribute">3个月内查询次数：</td>
						<td class="attribute-content">
							<Input v-model="client.credit_check_thirdmonth_num" style="width: 170px;"
								placeholder="3个月内查询次数" />&nbsp;次
						</td>
					</tr>
					<tr>
						<td class="attribute" style="width:13%">6个月内查询次数：</td>
						<td class="attribute-content">
							<Input v-model="client.credit_check_sixdmonth_num" style="width: 170px;"
								placeholder="6个月内查询次数" />&nbsp;次
						</td>
						<td class="attribute" style="width:13%">信用记录时长：</td>
						<td class="attribute-content">
							<Select v-model="client.credit_record_time" style="width: 170px">
								<Option value="0">0</Option>
								<Option value="6">1-6</Option>
								<Option value="7">>6</Option>
							</Select>&nbsp;月
						</td>
					</tr>
					<tr>
						<td class="attribute">两年内最严重的逾期：</td>
						<td class="attribute-content">
							<Select v-model="client.creditoverdue_twoyear" style="width: 170px">
								<Option value="1">1</Option>
								<Option value="2">2</Option>
								<Option value="3">3</Option>
								<Option value="4">4</Option>
								<Option value="5">5以上</Option>
							</Select>
						</td>
						<td class="attribute">一年内最严重的逾期：</td>
						<td class="attribute-content">
							<Select v-model="client.creditoverdue_oneyear" style="width: 170px">
								<Option value="1">1</Option>
								<Option value="2">2</Option>
								<Option value="3">3</Option>
								<Option value="4">4</Option>
								<Option value="5">5以上</Option>
							</Select>
						</td>
					</tr>
					<tr>
						<td class="attribute">半年内最严重的逾期：</td>
						<td class="attribute-content">
							<Select v-model="client.creditoverdue_halfyear" style="width: 170px">
								<Option value="1">1</Option>
								<Option value="2">2</Option>
								<Option value="3">3</Option>
								<Option value="4">4</Option>
								<Option value="5">5以上</Option>
							</Select>
						</td>
						<td class="attribute">当前是否逾期：</td>
						<td class="attribute-content">
							<Select v-model="client.creditoverdue_is" style="width: 170px">
								<Option value="1">是</Option>
								<Option value="0">否</Option>
							</Select>
						</td>
					</tr>
					<tr class="credits creditoverdue">
						<td class="attribute">当前逾期类型：</td>
						<td class="attribute-content">
							<Select v-model="client.creditoverdue_type" style="width: 170px">
								<Option value="1">贷记卡</Option>
								<Option value="2">贷款</Option>
							</Select>
						</td>
						<td class="attribute">当前逾期金额：</td>
						<td class="attribute-content">
							<Input v-model="client.creditoverdue_money" style="width: 170px;"
								placeholder="3个月内查询次数" />&nbsp;元
						</td>
					</tr>
					<tr>
						<td class="attribute">芝麻信用分：</td>
						<td class="attribute-content">
							<Select v-model="client.zhima_credit" style="width: 170px">
								<Option value="1">350~550</Option>
								<Option value="2">550~650</Option>
								<Option value="3">650以上</Option>
								<Option value="4">其他</Option>
							</Select>
						</td>
					</tr>
				</table>
				<div class="infomation-info-foot">
					<input value="保存" @click="saveClient" />
				</div>
			</div>
			<!-- 需求信息 -->
			<div class="infomation-info" v-if="clientType == 8">
				<table class="infomation-info-main">
					<tr>
						<td class="attribute">还款方式：</td>
						<td class="attribute-content">
							<Select v-model="client.loan_repayment_type" style="width: 170px">
								<Option value="1">等额本息</Option>
								<Option value="2">先息后本</Option>
							</Select>
						</td>
						<td class="attribute">贷款用途：</td>
						<td class="attribute-content"><Input v-model="client.loan_use" style="width: 170px;"
								placeholder="贷款用途" /></td>
					</tr>
					<tr>
						<td class="attribute">用款时间：</td>
						<td class="attribute-content">
							<DatePicker :transfer=true :value="client.loans_time"
								@on-change="(e) => {client.loans_time = e}" type="date" placeholder="请选择时间"
								style="width: 170px"></DatePicker>
						</td>
						<td class="attribute">期限：</td>
						<td class="attribute-content"><Input v-model="client.loans_period" style="width: 170px;"
								placeholder="期限" />&nbsp;月</td>
					</tr>
				</table>
				<div class="infomation-info-foot"><input value="保存" @click="saveClient">
				</div>
			</div>
			<!-- 全部信息 -->
			<div class="infomation-info" id="infomation-info10" v-if="clientType == 9">
				<!-- 基本信息 -->
				<div>
					<h1 class="infomation-info-top">基本信息<span>BASIC INFORMATION</span></h1>
					<ul class="showdetails">
						<li class="showdetailsli">
							<div class="showdetailsname">姓名：</div>
							<div class="showdetailsinfo">
								<span>{{client.name}}</span>
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">手机号码：</div>
							<!-- 下面按钮去除点击事件 onclick="call_son($(this));" -->
							<input type="hidden" id="mykefu_kid" value="<{$kid}>">
							<div class="showdetailsinfo"> <span v-if="phoneShow">{{client.phone}}</span>
								<span v-if="!phoneShow">{{client.new_phone}}</span>
								<span class="icon iconfont icon-kejian" style="color: #259FF0; cursor: pointer;"
									@click="clickPhoneShow"></span>
								<span @click="callMobile">
									<Icon type="ios-call" size="30" color="#67C239" />
								</span>
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">申请城市：</div>
							<div class="showdetailsinfo">{{client.city}}</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">学历：</div>
							<div class="showdetailsinfo">
								<span v-if="client.education ==1">高中及以下</span>
								<span v-if="client.education ==2">大专</span>
								<span v-if="client.education ==3">本科</span>
								<span v-if="client.education ==4">研究生及以上</span>
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">年龄：</div>
							<div class="showdetailsinfo">{{client.age}}</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">婚姻：</div>
							<div class="showdetailsinfo">
								<div class="showdetailsinfo">
									<span v-if="client.maritalStatus ==1">已婚</span>
									<span v-if="client.maritalStatus ==2">未婚</span>
									<span v-if="client.maritalStatus ==3">离异</span>
									<span v-if="client.maritalStatus ==4">丧偶</span>
								</div>
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">性别：</div>
							<div class="showdetailsinfo"><span v-if="client.sex ==1">男</span><span
									v-if="client.sex ==2">女</span></div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">毕业院校：</div>
							<div class="showdetailsinfo">{{client.school}}</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">客户公司：</div>
							<div class="showdetailsinfo">{{client.company}}</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">申请额度：</div>
							<div class="showdetailsinfo">{{client.loans_money}}</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">来源：</div>
							<div class="showdetailsinfo">{{client.source}}</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">是否本地人：</div>
							<div class="showdetailsinfo">
								<div class="showdetailsinfo">
									<span v-if="client.is_local_region ==1">是</span>
									<span v-if="client.is_local_region ==-1">否</span>
									<span v-if="client.is_local_region ==0">未知</span>
								</div>
							</div>
						</li>
						<div style="clear:both;"></div>
					</ul>
				</div>
				<div>
					<h1 class="infomation-info-top">身份信息<span>IDENTITY INFORMATION</span></h1>
					<ul class="showdetails">
						<li class="showdetailsli">
							<div class="showdetailsname">客户类型：</div>
								  <div>
									<span class="license-toggle" :class="{ active: withLicense }" @click="toggleWithLicense">有营业执照</span>
									<span class="license-toggle" :class="{ active: !withLicense }" @click="toggleWithoutLicense">无营业执照</span>
								  </div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">公积金：</div>
							<div class="showdetailsinfo">
								<span v-if="client.is_accumulation ==1">有</span>
								<span v-if="client.is_accumulation ==0">无</span>
								<span v-if="client.is_accumulation ==-1">未知</span>
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">社保：</div>
							<div class="showdetailsinfo">
								<span v-if="client.is_social_security ==1">有</span>
								<span v-if="client.is_social_security ==0">无</span>
								<span v-if="client.is_social_security ==-1">未知</span>
							</div>
						</li>
						<li class="showdetailsli"
							v-if="client.social_security_cardinal_number != '' && client.social_security_cardinal_number != '0'&& (client.type == 1)">
							<div class="showdetailsname">公积金缴存基数：</div>
							<div class="showdetailsinfo">{{client.social_security_cardinal_number}}&nbsp;元</div>
						</li>
						<li class="showdetailsli"
							v-if="client.work_gongjijin_jiaocunmoney != ''&& client.work_gongjijin_jiaocunmoney != '0' && (client.type == 1 )">
							<div class="showdetailsname">个人+公司公积金缴存额：</div>
							<div class="showdetailsinfo">{{client.work_gongjijin_jiaocunmoney}}&nbsp;元</div>
						</li>
						<li class="showdetailsli"
							v-if="client.accumulation_fund_buy_time != '' && client.accumulation_fund_buy_time != '0'&& (client.type == 1)">
							<div class="showdetailsname">公积金缴存时长：</div>
							<div class="showdetailsinfo">{{client.accumulation_fund_buy_time}}&nbsp;月</div>
						</li>
						<li class="showdetailsli"
							v-if="client.social_security_cardinal_number != ''&& client.social_security_cardinal_number != '0' && (client.type == 1 )">
							<div class="showdetailsname">社保缴存基数：</div>
							<div class="showdetailsinfo">{{client.social_security_cardinal_number}}&nbsp;元</div>
						</li>
						<li class="showdetailsli"
							v-if="client.social_security_buy_time != ''&& client.social_security_buy_time != '0' && (client.type == 1)">
							<div class="showdetailsname">社保缴存时长：</div>
							<div class="showdetailsinfo">{{client.social_security_buy_time}}&nbsp;月</div>
						</li>
						<li class="showdetailsli"
							v-if="client.social_security_cardinal_number != ''&& client.social_security_cardinal_number != '0' && (client.type == 1)">
							<div class="showdetailsname">发放方式：</div>
							<div class="showdetailsinfo">
								<span v-if="client.income_type ==1">银行代发</span>
								<span v-if="client.income_type ==2">银行转账</span>
								<span v-if="client.income_type ==3">微信、支付宝或现金</span>
								<span v-if="client.income_type ==4">股东分红或利润</span>
								<span v-if="client.income_type ==5">其他</span>
							</div>
						</li>
						<li class="showdetailsli"
							v-if="client.income_sum != '' && client.income_sum != '0'&& (client.type == 1)">
							<div class="showdetailsname">月收入：</div>
							<div class="showdetailsinfo">{{client.income_sum}}&nbsp;元</div>
						</li>
						<li class="showdetailsli"
							v-if="client.work_income_long != '' && client.work_income_long != '0' && (client.type == 1 )">
							<div class="showdetailsname">工资发放时长：</div>
							<div class="showdetailsinfo">{{client.work_income_long}}&nbsp;月</div>
						</li>

						<li class="showdetailsli" v-if="client.is_business_license != '' && (client.type == 2)">
							<div class="showdetailsname">有无营业执照：</div>
							<div class="showdetailsinfo">
								<span v-if="client.is_business_license ==1">无</span>
								<span v-if="client.is_business_license ==2">有营业执照</span>
							</div>
						</li>
						<li class="showdetailsli" v-if="client.business_gufen != '' && (client.type == 2)">
							<div class="showdetailsname">占股比例：</div>
							<div class="showdetailsinfo">{{client.business_gufen}}&nbsp;%</div>
						</li>
						<li class="showdetailsli" v-if="client.business_years != '' && (client.type == 2)">
							<div class="showdetailsname">经营年限：</div>
							<div class="showdetailsinfo">{{client.business_years}}&nbsp;年</div>
						</li>
						<li class="showdetailsli" v-if="client.income_sum != '' && (client.type == 2)">
							<div class="showdetailsname">月收入：</div>
							<div class="showdetailsinfo">{{client.income_sum}}&nbsp;元</div>
						</li>
						<li class="showdetailsli" v-if="client.credit_rate != '' && (client.type == 2)">
							<div class="showdetailsname">信用评级：</div>
							<div class="showdetailsinfo">
								<span v-if="client.credit_rate ==1">A级</span>
								<span v-if="client.credit_rate ==2">B级</span>
								<span v-if="client.credit_rate ==3">C级</span>
								<span v-if="client.credit_rate ==4">D级</span>
								<span v-if="client.credit_rate ==5">M级</span>
							</div>
						</li>
						<div style="clear:both;"></div>
					</ul>
				</div>
				<!-- 房产信息 -->

				<div v-if="client.is_house ==1">
					<h1 class="infomation-info-top">房产信息<span>REAL ESTATE INFORMATION</span></h1>
					<ul class="showdetails">
						<li class="showdetailsli">
							<div class="showdetailsname">名下房产情况：</div>
							<div class="showdetailsinfo">
								<span v-if="client.is_house ==1">有</span>
								<span v-if="client.is_house ==0">无</span>
							</div>
						</li>

						<li class="showdetailsli" v-if="client.house_type !=0 || client.house_type != ''">
							<div class="showdetailsname">房产类型：</div>
							<div class="showdetailsinfo">
								<span v-if="client.house_type ==1">商品房</span>
								<span v-if="client.house_type ==2">居民住房</span>
								<span v-if="client.house_type ==3">商住两用</span>
								<span v-if="client.house_type ==4">商铺</span>
								<span v-if="client.house_type ==5">公寓</span>
								<span v-if="client.house_type ==6">写字楼</span>
								<span v-if="client.house_type ==7">别墅</span>
								<span v-if="client.house_type ==8">宅基地</span>
								<span v-if="client.house_type ==9">安置房</span>
								<span v-if="client.house_type ==10">集资房</span>
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">房产所在地：</div>
							<div class="showdetailsinfo">
								{{client.house_location}}
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">房产现价：</div>
							<div class="showdetailsinfo">
								{{client.houseSum}}&nbsp;万
							</div>
						</li>

						<li class="showdetailsli">
							<div class="showdetailsname">房产面积：</div>
							<div class="showdetailsinfo">
								{{client.house_area}}&nbsp;平方米
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">房产证持有时间：</div>
							<div class="showdetailsinfo">
								{{client.house_buy_time}}&nbsp;月
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">房产状态：</div>
							<div class="showdetailsinfo">
								<span v-if="client.house_status ==1">抵押给私人</span>
								<span v-if="client.house_status ==2">抵押给银行</span>
								<span v-if="client.house_status ==3">购房按揭中</span>
								<span v-if="client.house_status ==4">全款红本在手</span>
							</div>
						</li>

						<li class="showdetailsli">
							<div class="showdetailsname">月供时间：</div>
							<div class="showdetailsinfo">
								{{client.monthlyPeriod}}&nbsp;月
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">月供金额：</div>
							<div class="showdetailsinfo">
								{{client.monthlySum}}&nbsp;元
							</div>
						</li>

						<div style="clear:both;"></div>
					</ul>
				</div>

				<!-- 车产信息 -->

				<div v-if="client.is_car ==1">
					<h1 class="infomation-info-top">车产信息<span>VEHICLE PRODUCTION INFORMATION</span></h1>
					<ul class="showdetails">
						<li class="showdetailsli">
							<div class="showdetailsname">名下车产情况：</div>
							<div class="showdetailsinfo">
								<span v-if="client.is_car ==1">有</span>
								<span v-if="client.is_car ==0">无</span>
							</div>
						</li>

						<li class="showdetailsli">
							<div class="showdetailsname">汽车类型：</div>
							<div class="showdetailsinfo">
								<span v-if="client.is_car ==1">小轿车</span>
								<span v-if="client.is_car ==2">房车</span>
								<span v-if="client.is_car ==3">货车</span>
								<span v-if="client.is_car ==4">工程车</span>
							</div>
						</li>

						<li class="showdetailsli">
							<div class="showdetailsname">归属地：</div>
							<div class="showdetailsinfo">
								{{client.car_location}}
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">使用年限：</div>
							<div class="showdetailsinfo">
								{{client.car_years}}&nbsp;年
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">车辆价值：</div>
							<div class="showdetailsinfo">
								{{client.car_valuation_money}}&nbsp;万
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">车险公司：</div>
							<div class="showdetailsinfo">
								{{client.car_brands}}
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">当前保单缴费次数：</div>
							<div class="showdetailsinfo">
								{{client.car_baodan_paynum}}&nbsp;次
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">车辆状态：</div>
							<div class="showdetailsinfo">
								<span v-if="client.car_mortgage_status ==1">按揭车</span>
								<span v-if="client.car_mortgage_status ==2">全款车</span>
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">月供金额：</div>
							<div class="showdetailsinfo">
								{{client.car_repayment_month}}&nbsp;元
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">月供时间：</div>
							<div class="showdetailsinfo">
								{{client.car_repayment_month}}&nbsp;月
							</div>
						</li>

						<div style="clear:both;"></div>
					</ul>
				</div>

				<!-- 保单信息 -->

				<div v-if="client.policyShow ==1">
					<h1 class="infomation-info-top">保单信息<span>POLICY INFORMATION</span></h1>
					<ul class="showdetails">
						<li class="showdetailsli">
							<div class="showdetailsname">有无保单：</div>
							<div class="showdetailsinfo">
								<span v-if="client.policyShow ==1">有</span>
								<span v-if="client.policyShow ==0">无</span>
							</div>
						</li>

						<li class="showdetailsli">
							<div class="showdetailsname">保单公司：</div>
							<div class="showdetailsinfo">
								{{client.policy_name}}
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">年缴费额：</div>
							<div class="showdetailsinfo">
								{{client.policy_pay_money}}&nbsp;元
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">已缴次数：</div>
							<div class="showdetailsinfo">
								{{client.policy_buy_time}}&nbsp;次
							</div>
						</li>

						<div style="clear:both;"></div>
					</ul>
				</div>

				<!-- 信用信息 -->

				<div>
					<h1 class="infomation-info-top">信用信息<span>CREDIT INFORMATION</span></h1>
					<ul class="showdetails">
						<li class="showdetailsli"
							v-if="client.credit_check_twomonth_num != '' && client.credit_check_twomonth_num != '0'">
							<div class="showdetailsname">2个月内查询次数：</div>
							<div class="showdetailsinfo">
								{{client.credit_check_twomonth_num}}&nbsp;次
							</div>
						</li>
						<li class="showdetailsli"
							v-if="client.credit_check_thirdmonth_num != '' && client.credit_check_thirdmonth_num != '0'">
							<div class="showdetailsname">3个月内查询次数：</div>
							<div class="showdetailsinfo">
								{{client.credit_check_thirdmonth_num}}
								&nbsp;次
							</div>
						</li>
						<li class="showdetailsli"
							v-if="client.credit_check_sixdmonth_num != '' && client.credit_check_sixdmonth_num != '0'">
							<div class="showdetailsname">6个月内查询次数：</div>
							<div class="showdetailsinfo">
								{{client.credit_check_sixdmonth_num}}
								&nbsp;次
							</div>
						</li>
						<li class="showdetailsli"
							v-if="client.credit_record_time != '' && client.credit_record_time != '0'">
							<div class="showdetailsname">信用记录时长：
							</div>
							<div class="showdetailsinfo">
								{{client.credit_record_time}}&nbsp;月
							</div>
						</li>

						<li class="showdetailsli"
							v-if="client.creditoverdue_twoyear != '' && client.creditoverdue_twoyear != '0'">
							<div class="showdetailsname">
								两年内最严重的逾期：</div>
							<div class="showdetailsinfo">
								{{client.creditoverdue_twoyear}}
							</div>
						</li>

						<li class="showdetailsli"
							v-if="client.creditoverdue_oneyear != '' && client.creditoverdue_oneyear != '0'">
							<div class="showdetailsname">
								一年内最严重的逾期：</div>
							<div class="showdetailsinfo">
								{{client.creditoverdue_oneyear}}
							</div>
						</li>

						<li class="showdetailsli"
							v-if="client.creditoverdue_halfyear != '' && client.creditoverdue_halfyear != '0'">
							<div class="showdetailsname">
								半年内最严重的逾期：
							</div>
							<div class="showdetailsinfo">
								{{client.creditoverdue_halfyear}}
							</div>
						</li>

						<li class="showdetailsli" v-if="client.creditoverdue_is != ''">
							<div class="showdetailsname">
								当前是否逾期：
							</div>
							<div class="showdetailsinfo">
								<span v-if="client.creditoverdue_is ==1">是</span>
								<span v-if="client.creditoverdue_is ==0">否</span>
							</div>
						</li>

						<li class="showdetailsli"
							v-if="client.creditoverdue_type != '' && client.creditoverdue_type != '0'">
							<div class="showdetailsname">
								当前逾期类型：
							</div>
							<div class="showdetailsinfo">
								<span v-if="client.creditoverdue_type ==1">信用卡</span>
								<span v-if="client.creditoverdue_type ==2">贷款</span>
							</div>
						</li>
						<li class="showdetailsli"
							v-if="client.creditoverdue_money != '' && client.creditoverdue_money != '0'">
							<div class="showdetailsname">
								当前逾期金额：
							</div>
							<div class="showdetailsinfo">
								{{client.creditoverdue_money}}
								&nbsp;元
							</div>
						</li>

						<li class="showdetailsli" v-if="client.weilidai_sum != '' && client.weilidai_sum != '0'">
							<div class="showdetailsname">
								微粒贷额度：
							</div>
							<div class="showdetailsinfo">
								<span v-if="client.weilidai_sum ==1">5000</span>
								<span v-if="client.weilidai_sum ==2">10000</span>
								<span v-if="client.weilidai_sum ==3">20000</span>
								<span v-if="client.weilidai_sum ==4">30000</span>
								<span v-if="client.weilidai_sum ==5">50000</span>
								<span v-if="client.weilidai_sum ==6">50000以上</span>
							</div>
						</li>
						<li class="showdetailsli" v-if="client.zhima_credit != '' && client.zhima_credit != '0'">
							<div class="showdetailsname">
								芝麻信用分：
							</div>
							<div class="showdetailsinfo">
								<span v-if="client.zhima_credit ==1">350~550</span>
								<span v-if="client.zhima_credit ==2">550~650</span>
								<span v-if="client.zhima_credit ==3">650以上</span>
								<span v-if="client.zhima_credit ==4">其他</span>
							</div>
						</li>

						<div style="clear:both;">
						</div>
					</ul>
				</div>

				<!-- 需求信息 -->
				<div>
					<h1 class="infomation-info-top">需求信息<span>DEMAND
							INFORMATION</span></h1>
					<ul class="showdetails">
						<li class="showdetailsli">
							<div class="showdetailsname">还款方式：</div>
							<div class="showdetailsinfo">
								<span v-if="client.loan_repayment_type ==1">等额本息</span>
								<span v-if="client.loan_repayment_type ==2">先息后本</span>
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">贷款用途：</div>
							<div class="showdetailsinfo">
								{{client.loan_use}}
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">用款时间：</div>
							<div class="showdetailsinfo">
								{{client.loans_time}}
							</div>
						</li>
						<li class="showdetailsli">
							<div class="showdetailsname">贷款期限：</div>
							<div class="showdetailsinfo">
								{{client.loans_period}}&nbsp;月
							</div>
						</li>
						<div style="clear:both;"></div>
					</ul>
				</div>

			</div>
		</div>
		<div class="infobottom opxia">
			<ul class="tolinfobottom" style="background:#bebebe">
				<li :class="{'active': tabType == 1}" data-type="1" @click="changeTabType">客户跟踪</li>
				<li :class="{'active': tabType == 2}" data-type="2" @click="changeTabType">
					<Badge overflow-count="999"></Badge>
					分配记录
				</li>
				<li :class="{'active': tabType == 3}" data-type="3" @click="changeTabType"
					v-if="userInfo.role_type == 4 || userInfo.role_type == 5">
					录音
				</li>
				<li :class="{'active': tabType == 4}" data-type="4" @click="changeTabType">
					附件
				</li>
				<span style="margin-left: 15px;line-height: 35px;">申请时间：{{client.applied_at}}</span>
			</ul>
			<div v-if="tabType == 4">
				<ClientFile :client_id="id"></ClientFile>
			</div>
			<div v-if="tabType == 3">
				<Button type="primary" @click="beforeOne" style="margin-left:5px;">上一条</Button>
				<Button type="primary" @click="nextOne" style="margin-left:5px;">下一条</Button>
				<ul class="hisul"
					style="float:left;margin-left:1.3%;height: auto; min-height:85px;width:90%;margin-top:6px;">
					<h3>如不能播放请复制链接到浏览器下载到手机打开qq音乐，网易云音乐等播放器播放</h3>
					<li style="border-bottom:1px dashed #666;height:auto;float:left;width:100%"
						v-for="(item, index) in recordList" :key="index">
						<div style="width:100%">
							<Record ref="record" :record="item"></Record>
						</div>
					</li>
				</ul>
			</div>
			<div v-if="tabType == 2">
				<div class="bottop">
					<span class="bottit">ID:{{client.id}}</span>
					<span class="bottit" style="display:inline;position:relative">
						<Tooltip placement="top" max-width="600">
							<div slot="content" v-if="userInfo.shop_id == 14">
								<div>1:本地人 2:社保 3:打卡工资 4:公积金</div>
								<div>5:公司 6:全国按揭房</div>
								<div>7:本地房</div>
								<div>
									<hr>
								</div>
								<div>0星： 系统默认的未了解过信息的客户 </div>
								<div>1星： 资质全无</div>
								<div>2星： 1,2有其一</div>
								<div>2+星： 1,2,3,4选二</div>
								<div>3星： 3，4，5，6有其二</div>
								<div>4星： 有7，或1,2,3，4,5,6任选3</div>
							</div>
							<div slot="content" v-if="userInfo.shop_id != 14">
								<div>0星：系统默认的未了解过信息的客户 </div>
								<div>1星：本人或身边朋友无可贷点的客户</div>
								<div>2星：本人或身边朋友有可贷点但暂时进不了件的客户</div>
								<div>2+星：可以做主流小贷，需邀约上门的客户</div>
								<div>3星：本人或身边朋友有可贷点，可以做银行的客户</div>
								<div>4星：有可贷点，且马上需要或条件优质，可以做银行的客户</div>
							</div>
							<span class="icon iconfont icon-star"
								style="color: #FEC97C; cursor: pointer;">客户星级&nbsp;：</span>
						</Tooltip>
						<Select @on-change="saveClient" v-model="client.start" style="width:120px">
							<Option v-for="item in rateList" :value="item.value" :key="item.value">
								{{ item.label }}
							</Option>
						</Select>
						<ul class="exinfo" id="ex1">
							<li><span class="cr">0&nbsp;&nbsp;星</span>：系统默认的未了解过信息的客户 ；</li>
							<li><span class="cr">1&nbsp;&nbsp;星</span>：本人或身边朋友无可贷点的客户；</li>
							<li><span class="cr">2&nbsp;&nbsp;星</span>：本人或身边朋友有可贷点但暂时进不了件的客户； </li>
							<li><span class="cr">2星+</span>：可以做主流小贷，需邀约上门的客户； </li>
							<li><span class="cr">3&nbsp;&nbsp;星</span>：本人或身边朋友有可贷点，可以做银行的客户；</li>
							<li><span class="cr">4&nbsp;&nbsp;星</span>：有可贷点，且马上需要或条件优质，可以做银行的客户（存量客户默认4星）； </li>
						</ul>
					</span>
					<span class="bottit" style="position:relative">客户状态&nbsp;<img
							src="<{$cdnsite}>/default/manage/images/explain_icon01.jpg" class="eximg" id="2">：
						<Select @on-change="saveClient" v-model="client.status" style="width:120px">
							<Option v-for="item in stateList" :disabled="item.is_true==1?true:false"
								:class="{statusbtn:item.is_true==1}" :value="item.value" :key="item.value">
								{{ item.label }}
							</Option>
						</Select>
						<input type="hidden" id="statusnumval">
						<ul class="exinfo" style="width:455px;top:-205px;left:47px" id="ex2">
							<li><span class="cr">0.待跟进</span>：尝试联系，但未了解客户信息；</li>
							<li><span class="cr">1.贷款资质不符</span>：该客户或身边人士无可贷点，或同行、骚扰等无效申请；</li>
							<li><span class="cr">2.待签约</span>：联系后，并判定该客户或身边人士有可贷点； </li>
							<li><span class="cr">3.已签约</span>：已上门签约；</li>
							<li><span class="cr">4.审核中</span>：客户已经完成进件，银行审核中，请备注进件银行、申请金额、审核进度； </li>
							<li><span class="cr">5.银行已放款</span>：银行审批结束，批放款成功，请备注放款银行、到账金额； </li>
							<li><span class="cr">6.银行已拒绝</span>：银行审批结束，贷款被拒（包含初审），请备注被拒的原因； </li>
						</ul>
						<ul class="exinfo" style="width:245px;top:25px;left:50px" id="ex3">
							<li><span class="cr">备忘解析：</span>每3分钟提示一次,提醒后按确定就会自动关闭，也可以手动关闭；</li>
						</ul>
					</span>
					<span class="bottit" style="position:relative">拓客意向&nbsp;
						<Select @on-change="saveClient" v-model="client.introduce_status" style="width:150px">
							<Option v-for="item in introduceStatusList" :value="item.value" :key="item.value">
								{{ item.label }}
							</Option>
						</Select>
					</span>
					<span class="bottit" style="margin-left: 3px;">
						<span>当前跟进人：</span>
						<span>{{client.follow_name}}</span>
					</span>
					<Button type="primary" @click="beforeOne" style="margin-left:5px;">上一条</Button>
					<Button type="primary" @click="nextOne" style="margin-left:5px;">下一条</Button>

					<Button v-if="client.is_redistribution == 1" style="margin-left:5px;" type="primary"
						@click="addToMyClient">转至我的客户</Button>
					<Button v-if="client.is_redistribution == 0" style="margin-left:5px;" type="primary"
						@click="addToMyClient">转至再分配客户</Button>
					<Button v-if="client.is_lock == -1" style="margin-left:5px;"
						class="icon iconfont icon-duomeitiicon- img_font" type="primary" @click="lock">锁定</Button>
					<Button v-if="client.is_lock == 1" style="margin-left:5px;"
						class="icon iconfont icon-duomeitiicon- img_font" type="primary" @click="lock">解锁</Button>
					<Button type="primary" @click="addPool" style="margin-left:5px;">放入公共池</Button>
				</div>
				<span class="botmale" style="float:left">分配记录</span>
				<ul class="hisul"
					style="float:left;margin-left:1.3%;height: auto; min-height:85px;width:90%;margin-top:6px;">
					<li style="border-bottom:1px dashed #666;height:auto;float:left;width:100%"
						v-for="(item, index) in distributionLogList" :key="index">
						<div style="width:100%">
							<div style="width:3%;float:left;"><em class="number">{{index+1}}</em>.</div>
							<div
								style="float:left;width:97%;display:block;word-break: break-all;word-wrap: break-word;">
								<a style="color:black;text-decoration:none;cursor:auto">{{item.content}}
									<span style="margin:0 2% 0 5%">{{item.created_at}}</span>
								</a>
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div v-if="tabType == 1">
				<div class="bottop">
					<span class="bottit">ID:{{client.id}}</span>
					<span class="bottit" style="display:inline;position:relative">
						<Tooltip placement="top" max-width="600">
							<div slot="content" v-if="userInfo.shop_id == 14">
								<div>1:本地人 2:社保 3:打卡工资 4:公积金</div>
								<div>5:公司 6:全国按揭房</div>
								<div>7:本地房</div>
								<div>
									<hr>
								</div>
								<div>0星： 系统默认的未了解过信息的客户 </div>
								<div>1星： 资质全无</div>
								<div>2星： 1,2有其一</div>
								<div>2+星： 1,2,3,4选二</div>
								<div>3星： 3，4，5，6有其二</div>
								<div>4星： 有7，或1,2,3，4,5,6任选3</div>
							</div>
							<div slot="content" v-if="userInfo.shop_id != 14">
								<div>0星：系统默认的未了解过信息的客户 </div>
								<div>1星：本人或身边朋友无可贷点的客户</div>
								<div>2星：本人或身边朋友有可贷点但暂时进不了件的客户</div>
								<div>2+星：可以做主流小贷，需邀约上门的客户</div>
								<div>3星：本人或身边朋友有可贷点，可以做银行的客户</div>
								<div>4星：有可贷点，且马上需要或条件优质，可以做银行的客户</div>
							</div>
							<span class="icon iconfont icon-star"
								style="color: #FEC97C; cursor: pointer;">客户星级&nbsp;：</span>
						</Tooltip>
						<Select @on-change="saveClient" v-model="client.start" style="width:120px">
							<Option v-for="item in rateList" :value="item.value" :key="item.value">
								{{ item.label }}
							</Option>
						</Select>
						<ul class="exinfo" id="ex1">
							<li><span class="cr">0&nbsp;&nbsp;星</span>：系统默认的未了解过信息的客户 ；</li>
							<li><span class="cr">1&nbsp;&nbsp;星</span>：本人或身边朋友无可贷点的客户；</li>
							<li><span class="cr">2&nbsp;&nbsp;星</span>：本人或身边朋友有可贷点但暂时进不了件的客户； </li>
							<li><span class="cr">2星+</span>：可以做主流小贷，需邀约上门的客户； </li>
							<li><span class="cr">3&nbsp;&nbsp;星</span>：本人或身边朋友有可贷点，可以做银行的客户；</li>
							<li><span class="cr">4&nbsp;&nbsp;星</span>：有可贷点，且马上需要或条件优质，可以做银行的客户（存量客户默认4星）； </li>
						</ul>
					</span>
					<span class="bottit" style="position:relative">客户状态&nbsp;<img
							src="<{$cdnsite}>/default/manage/images/explain_icon01.jpg" class="eximg" id="2">：
						<Select @on-change="saveClient" v-model="client.status" style="width:120px">
							<Option v-for="item in stateList" :disabled="item.is_true==1?true:false"
								:class="{statusbtn:item.is_true==1}" :value="item.value" :key="item.value">
								{{ item.label }}
							</Option>
						</Select>
						<input type="hidden" id="statusnumval">
						<ul class="exinfo" style="width:455px;top:-205px;left:47px" id="ex2">
							<li><span class="cr">0.待跟进</span>：尝试联系，但未了解客户信息；</li>
							<li><span class="cr">1.贷款资质不符</span>：该客户或身边人士无可贷点，或同行、骚扰等无效申请；</li>
							<li><span class="cr">2.待签约</span>：联系后，并判定该客户或身边人士有可贷点； </li>
							<li><span class="cr">3.已签约</span>：已上门签约；</li>
							<li><span class="cr">4.审核中</span>：客户已经完成进件，银行审核中，请备注进件银行、申请金额、审核进度； </li>
							<li><span class="cr">5.银行已放款</span>：银行审批结束，批放款成功，请备注放款银行、到账金额； </li>
							<li><span class="cr">6.银行已拒绝</span>：银行审批结束，贷款被拒（包含初审），请备注被拒的原因； </li>
						</ul>
						<ul class="exinfo" style="width:245px;top:25px;left:50px" id="ex3">
							<li><span class="cr">备忘解析：</span>每3分钟提示一次,提醒后按确定就会自动关闭，也可以手动关闭；</li>
						</ul>
					</span>
					<span class="bottit" style="position:relative">拓客意向&nbsp;
						<Select @on-change="saveClient" v-model="client.introduce_status" style="width:150px">
							<Option v-for="item in introduceStatusList" :value="item.value" :key="item.value">
								{{ item.label }}
							</Option>
						</Select>
					</span>
					<span class="bottit" style="margin-left: 3px;">
						<span>当前跟进人：</span>
						<span>{{client.follow_name}}</span>
					</span>
					<Button type="primary" @click="beforeOne" style="margin-left:5px;">上一条</Button>
					<Button type="primary" @click="nextOne" style="margin-left:5px;">下一条</Button>

					<Button v-if="client.is_redistribution == 1" style="margin-left:5px;" type="primary"
						@click="addToMyClient">转至我的客户</Button>
					<Button v-if="client.is_redistribution == 0" style="margin-left:5px;" type="primary"
						@click="addToMyClient">转至再分配客户</Button>
					<Button v-if="client.is_lock == -1" style="margin-left:5px;"
						class="icon iconfont icon-duomeitiicon- img_font" type="primary" @click="lock">锁定</Button>
					<Button v-if="client.is_lock == 1" style="margin-left:5px;"
						class="icon iconfont icon-duomeitiicon- img_font" type="primary" @click="lock">解锁</Button>
					<Button type="primary" @click="addPool" style="margin-left:5px;">放入公共池</Button>
				</div>
				<!--div class="bottommain">
				<div id="kefuforget">
					<Dropdown style="margin-left: 20px" @on-click="changeMenu">
						<Button type="primary">
							生成邀约名片
							<Icon type="ios-arrow-down"></Icon>
						</Button>
						<DropdownMenu slot="list">
							<DropdownItem name="invate_door">邀约上门</DropdownItem>
							<DropdownItem name="invate_introduce">拓客邀约</DropdownItem>
						</DropdownMenu>
					</Dropdown>
				</div>
			</div-->
				<div class="bottommain">
					<div id="kefuforget">
						<span class="botmale">新增备忘</span>
						<span style="margin-left:1%;">日期：</span>
						<DatePicker type="date" :value="follow.follow_time_date"
							@on-change="(e) => {follow.follow_time_date = e}" style="width: 112px">
						</DatePicker>
						<TimePicker type="time" v-model="follow.follow_time_hour" style="width: 95px">
						</TimePicker>
						<span>提醒内容<img src="<{$cdnsite}>/default/manage/images/explain_icon01.jpg" class="eximg"
								id="3">：</span>
						<input type="text" class="botshu" v-model="follow.remark" style="width:40.6%">
						<Button type="primary" style="margin-left:20px ;" @click="saveFollow(1)">
							保存备忘
						</Button>
					</div>
					<div style="margin-top: 10px;">
						<span class="botmale">预约上门</span>
						<span style="margin-left:1%;">日期：</span>
						<DatePicker type="date" :value="follow.door_time_date"
							@on-change="(e) => {follow.door_time_date = e}" style="width: 112px">
						</DatePicker>
						<TimePicker type="time" v-model="follow.door_time_hour" style="width: 95px">
						</TimePicker>
						<span>备注<img src="<{$cdnsite}>/default/manage/images/explain_icon01.jpg" class="eximg"
								id="3">：</span>
						<input type="text" class="botshu" v-model="follow.remark" style="width:40.6%">
						<Button type="primary" style="margin-left:20px ;" @click="saveFollow(2)">
							保存
						</Button>
					</div>
					<div style="margin-top:5px;">
						<span class="botmale">新增记录</span>
						<Input v-model="remarkValue" type="textarea" class="botshu" :rows="2" style="width:61.5%" />
						<Button type="primary" style="margin-left:20px ;" @click="addRemark">
							保存
						</Button>
					</div>

					<div class="clearfix"></div>
					<span class="botmale" style="float:left;">顾问记录</span>
					<ul class="hisul" id="hisul"
						style="float:left;margin-left:1.3%;height: auto; min-height:85px;width:45%;margin-top:6px;">
						<li style="border-bottom:1px dashed #666;height:auto;float:left;width:100%"
							v-for="(item, index) in followLogList" :key="index">
							<div style="width:100%">
								<div style="width:3%;float:left;"><em class="number">{{index+1}}</em>.</div>
								<div
									style="float:left;width:97%;display:block;word-break: break-all;word-wrap: break-word;">
									<a style="color:black;text-decoration:none;cursor:auto">{{item.content}}
										<span style="margin:0 2% 0 5%">{{item.created_at}}</span>
									</a>
								</div>
							</div>
						</li>
					</ul>
					<ul class="hisul" id="hisul"
						style="float:left;margin-left:1.3%;height: auto; min-height:85px;width:45%;margin-top:6px;">

						<Input v-model="commentValue" type="textarea" placeholder="请输入主管点评" class="botshu" :rows="2" style="width:61.5%" />
						<Button type="primary" style="margin-left:20px ;" @click="saveComment">
								保存
						</Button>
						<li style="border-bottom:1px dashed #666;height:auto;float:left;width:100%"
							v-for="(item, index) in commentLogList" :key="index">
							<div style="width:100%">
								<div style="width:3%;float:left;"><em class="number">{{index+1}}</em>.</div>
								<div
									style="float:left;width:97%;display:block;word-break: break-all;word-wrap: break-word;">
									<a style="color:black;text-decoration:none;cursor:auto">{{item.content}}
										<span style="margin:0 2% 0 5%">{{item.created_at}}</span>
									</a>
								</div>
							</div>
						</li>
					</ul>
					<div style="clear: both;"></div>
					<span class="botmale" style="float:left">备忘记录</span>
					<ul class="hisul" id="hisul4"
						style="float:left;margin-left:1.3%;height: auto; min-height:85px;width:90%;margin-top:6px;">
						<li style="border-bottom:1px dashed #666;height:auto;float:left;width:100%"
							v-for="(item, index) in followList" :key="index">
							<div style="width:100%">
								<div
									style="float:left;width:97%;display:block;word-break: break-all;word-wrap: break-word;">
									<span style="margin-left:3%;">创建人：{{item.name}}</span>
									<span style="margin-left:3%;">定时时间：{{item.plan_at}}</span>
									<span style="margin-left:3%;">是否关闭：</span>
									<span style="margin-left:1%;">是</span>
									<span style="margin-left:3%;">创建时间：{{item.plan_at}}</span>
									<a title="<{$item.content_all}>"
										style="color:black;text-decoration:none;cursor:auto;margin-left:3%;">备注内容：{{item.remark}}
									</a>
								</div>
							</div>
						</li>
					</ul>
					<div class="clearfix"></div>
				</div>


			</div>
		</div>
		<Modal v-model="addVisitModal" title="上门资料">
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">约见时间</label>
				<DatePicker type="datetime" @on-change="makeTimeChange" :value="viewed_at" format="yyyy-MM-dd HH:mm:ss"
					placeholder="选择日期" style="width: 100%"></DatePicker>
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">处理状态</label>
				<Select v-model="status">
					<Option :value="-1">已上门-未谈妥</Option>
					<Option :value="-2">已上门-资质不符</Option>
					<Option :value="1">已签约</Option>
				</Select>
			</div>
			<div slot="footer">
				<Button type="text" @click="addVisitModal=false">取消</Button>
				<Button type="primary" @click="addVisit">确定</Button>
			</div>
		</Modal>
		<Modal v-model="introduceClientModal" width="45%" title="">
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">姓名</label>
				<Input v-model="introduceClient.introduce_name" placeholder="请输入姓名" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">性别</label>
				<Select v-model="introduceClient.introduce_sex">
					<Option :value="1">男</Option>
					<Option :value="2">女</Option>
				</Select>
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">电话号码</label>
				<Input v-model="introduceClient.introduce_phone" placeholder="请输入电话号码" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">处理状态</label>
				<Select v-model="introduceClient.introduce_status">
					<Option v-for="item in introduceStatus" :value="item.value" :key="item.value">{{ item.label }}
					</Option>
				</Select>
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label class="inline">客户介绍</label>
				<Input v-model="introduceClient.introduce_message" placeholder="请输入客户基本介绍" />
			</div>
			<div slot="footer">
				<Button type="text" @click="introduceClientModal=false">取消</Button>
				<Button type="primary" @click="saveIntroduceClient">确定</Button>
			</div>
		</Modal>
		<Modal v-model="addContractShow" width="900">
			<AddContract ref="addContract" @reloadData="loadData" :clientId="id"></AddContract>
			<div slot="footer">
				<Button type="primary" @click="$refs['addContract'].save()">确定</Button>
			</div>
		</Modal>
		<Modal v-model="invateDoorModal" width="45%" title="">
			<div class="flex flex_between" style="padding: 5px 30px">
				<label style="width: 100px;">客户姓名</label>
				<Input v-model="invateDoor.invate_name" placeholder="请输入姓名" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label style="width: 100px;">审批额度</label>
				<Input v-model="invateDoor.invate_money" placeholder="请输入预审额度" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label style="width: 100px;">面签日期</label>
				<DatePicker v-model="invateDoor.invate_day" type="date" placeholder="选择面签日期"
					@on-change="invateDayChange" style="width: 100%">
				</DatePicker>
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label style="width: 100px;">面签地址</label>
				<Input v-model="invateDoor.invate_address" placeholder="面签地址" />
			</div>
			<div class="flex flex_between" style="padding: 5px 30px">
				<label style="width: 100px;">面签材料</label>
				<Input v-model="invateDoor.invate_data" placeholder="面签材料" />
			</div>
			<div slot="footer">
				<Button type="text" @click="invateDoorModal=false">取消</Button>
				<Button type="primary" @click="saveInvateDoor">确定</Button>
			</div>
		</Modal>
	</div>
</template>
<script>
	import cityData from '../../assets/citydata.js'
	import '../../assets/css/client/infocss.css'
	import '../../assets/css/client/irtk.css'
	import '../../assets/css/client/client_info_new.css'
	import '../../assets/css/client/kefu_style.css'
	import ClientMessage from './ClientMessage.vue'
	import AddRecord from './AddRecord.vue'
	import AddClient from './AddClient.vue'
	import AddContract from '../task/AddContract.vue'
	import ClientFile from './components/ClientFile.vue'
	import Record from '../tool/record.vue'
	import config from '@/config'
	import {
		getTimeLater
	} from '@/api/tools'
	import {
		saveClient,
		savePolicy,
		saveCreditCard,
		saveDebt,
		getClient,
		saveComment,
		cancelTag,
		addVisit,
		getClientRecord,
		addClientTag,
		addRemark,
		addContactTag,
		saveFollow,
		lock,
		addPool,
		addToMyClient,
		eraseFollow,
		addEmergencyTag,
		saveIntroduceClient,
		lookPhone,
		saveIsCloseStatus,
		sendOrderNotice,
		sendOrderNoticeNew
	} from '@/api/client'
	import {
		mapMutations,
		mapActions,
		mapGetters
	} from "vuex";

	export default {
		name: "newEditClue",
		components: {
			AddRecord,
			ClientMessage,
			AddClient,
			AddContract,
			Record,
			ClientFile
		},
		computed: {
			...mapGetters(['userInfo', 'token']),
			remarksSaveStatus() {
				return this.$store.state.app.remarksSaveStatus
			},
		},
		watch: {
			$route() { // 监听路由变化  // 组件第一次进入不会执行
				if (this.$route.name == "newEditClue") {
					this.id = this.$route.params.id
				}
			},
			id() {
				this.loadData();
			},
		},
		created() {
			console.log(this.userInfo)
			this.id = this.$route.params.id
			this.loadData();
		},
		data() {
			return {
				id: '',
				withLicense: true,
				clientType: 9,
				tabType: 1,
				loanFoldShow: false,
				viewFoldShow: false,
				distributionFoldShow: false,
				commentFoldShow: false,
				followFoldShow: false,
				editTaskOp: false,
				addVisitModal: false,
				introduceClientModal: false,
				invateDoorModal: false,
				introduceCount: '',
				status: '',
				viewed_at: '',
				tabsList: [],
				invateDoor: {
					invate_name: '',
					invate_money: '',
					invate_day: '',
					invate_address: '',
					invate_data: '',
				},
				editModalStyle: {
					'top': '7%',
					'background': '#f9fafc',
					'border-radius': '15px'
				},
				firm: {
					name: '',
					identity: '0',
					stock: '',
					business: '',
					tax_number: '',
					tax_password: '',
					register_date: '',
					manage_time: '',
					water_sum: '',
					water_time: '',
					fund_sum: '',
					ratepaying_type: '0',
					year_ratepaying_sum: '',
					two_year_ratepaying_sum: '',
					ratepaying_duration: '',
					declaration_number: '',
					invoice_month_sum: '',
					invoice_year_sum: '',
					invoice_duration: '',
					credit_rate: '',
				},
				ratepaying_type_list: [{
					value: '1',
					label: '小规模纳税'
				}, {
					value: '2',
					label: '一般纳税人'
				}, ],
				identityList: [{
					value: '1',
					label: '法人'
				}, {
					value: '2',
					label: '股东'
				}, {
					value: '3',
					label: '监事'
				}, ],
				left_pages_show: true,
				appointment_is_close_list: [{
						value: 1,
						label: '是'
					},
					{
						value: -1,
						label: '否'
					}
				],
				remarkValue: '',
				cityData: cityData,
				client_message: {
					profession: '',
					income: '',
					income_sum: '',
					house: '',
					house_sum: '',
					car: '',
					car_sum: '',
					accumulation_fund: '',
					accumulation_fund_time: '',
					social_security: '',
					commercial_insurance: '',
					commercial_insurance_date: '',
					wei_li_dai: '',
					wei_li_dai_sum: '',
					credit_card: '',
					credit_card_sum: '',
					liabilities: '',
					liabilities_money: '',
				},
				introduceClient: {
					introduce_name: '',
					introduce_phone: '',
					introduce_sex: '',
					introduce_status: '',
					introduce_message: '',
				},
				client: {
					phone: '',
					certno: '',
					loans_money: '',
					loans_period: '',
					loans_time: '',
					age: '',
					education: '0',
					maritalStatus: '0',
					job_type: '0',
					houseShow: '0',
					houseMonthShow: 1,
					houseAllShow: 1,
					houseLandShow: 1,
					monthlySum: '',
					monthlyPeriod: '',
					monthly_time: '',
					monthly_location: [],
					houseSum: '',
					houseYears: '',
					buy_time: '',
					total_location: [],
					houseSelfSum: '',
					houseSelfArea: '',
					self_buy_time: '',
					self_total_location: [],
					carShow: '0',
					carMonthShow: '1',
					carAllShow: '1',
					monthly_car_show: '1',
					carSum: '',
					buy_car_time: '',
					car_location: '',
					total_car_show: '1',
					carTotalSum: '',
					car_id_time: '',
					total_car_location: '',
					policyShow: '1',
					is_social_security: '0',
					social_security_buy_time: '',
					social_security_cardinal_number: '',
					is_accumulation: '0',
					accumulation_fund_buy_time: '',
					accumulation_fund_cardinal_number: '',
					accumulation_fund_self_number: '',
					income_sum: '',
					income_type: '0',
					zhima_credit: '0',
					weilidaiShow: '0',
					weilidai_sum: '',
					credit_card_show: '0',
					debt_show: '0',
					city: [],
					introduce: '',
					overdue_or: 0,
					overdue_sum: '',
					overdue_or_6: '',
					overdue_or_12: '',
					overdue_or_24: '',
					overdue_6_number: '',
					overdue_6_days: '',
					overdue_12_number: '',
					overdue_12_days: '',
					overdue_24_number: '',
					overdue_24_days: '',
					unit_name: '',
					unit_contacts_name: '',
					unit_contacts_phone: '',
					unit_site: '',
					unit_entry_time: '',
					pay_taxes: '',

					type: 0,
					name: '',
					sex: 0,
					source: '',
					applied_at: '',
				},
				introduceStatus: [{
						value: 1,
						label: '未上门'
					},
					{
						value: 2,
						label: '已上门未能转化'
					},
					{
						value: 3,
						label: '已上门还可跟进'
					},
					{
						value: 4,
						label: '转化成功'
					}
				],
				maritalList: [{
						value: 1,
						label: '已婚'
					},
					{
						value: 2,
						label: '未婚'
					},
					{
						value: 3,
						label: '离异'
					},
					{
						value: 4,
						label: '丧偶'
					},
				],
				isLocalRegionList: [{
						value: 1,
						label: '是'
					},
					{
						value: -1,
						label: '否'
					},
					{
						value: 0,
						label: '未知'
					}
				],
				educationList: [{
						value: 1,
						label: '高中及以下'
					}, {
						value: 2,
						label: '大专'
					}, {
						value: 3,
						label: '本科'
					},
					{
						value: 4,
						label: '研究生及以上'
					},
				],
				clientTypeList: [{
					value: 1,
					label: '授薪'
				}, {
					value: 2,
					label: '自雇'
				}, ],
				houseTypeList: [{
						value: 1,
						label: '商品房'
					},
					{
						value: 2,
						label: '居民住房'
					},
					{
						value: 3,
						label: '商住两用'
					},
					{
						value: 4,
						label: '商铺'
					},
					{
						value: 5,
						label: '公寓'
					},
					{
						value: 6,
						label: '写字楼'
					},
					{
						value: 7,
						label: '别墅'
					},
					{
						value: 8,
						label: '宅基地'
					},
					{
						value: 9,
						label: '安置房'
					},
					{
						value: 10,
						label: '集资房'
					},
				],
				carTypeList: [{
						value: '1',
						label: '小轿车'
					},
					{
						value: '2',
						label: '房车'
					},
					{
						value: '3',
						label: '货车'
					},
					{
						value: ' 4',
						label: '工程车'
					}
				],
				carStatusList: [{
						value: '1',
						label: '按揭车'
					},
					{
						value: '2',
						label: '全款车'
					}
				],
				houseStatusList: [{
						value: 1,
						label: '抵押给私人'
					},
					{
						value: 2,
						label: '抵押给银行'
					},
					{
						value: 3,
						label: '购房按揭中'
					},
					{
						value: 4,
						label: '全款红本在手'
					}
				],
				jobTypeList: [{
						value: 1,
						label: '标薪'
					},
					{
						value: 2,
						label: '优良职业'
					},
					{
						value: 3,
						label: '自雇'
					},
					{
						value: 4,
						label: '无固定职业'
					},
					{
						value: 5,
						label: '企业税贷'
					},
				],
				policy_people_name_list: [{
					value: '本人',
					label: '本人'
				}, {
					value: '他人',
					label: '他人'
				}, ],
				payment_type_list: [{
						value: '年交',
						label: '年交'
					},
					{
						value: '月交',
						label: '月交'
					},
					{
						value: '季交',
						label: '季交'
					},
					{
						value: '趸交',
						label: '趸交'
					},
				],
				policy_type_list: [{
						value: '寿险年金',
						label: '寿险年金'
					},
					{
						value: '分红型',
						label: '分红型'
					},
					{
						value: '传统型',
						label: '传统型'
					},
					{
						value: '大病型',
						label: '大病型'
					},
					{
						value: '趸交型',
						label: '趸交型'
					},
					{
						value: '其他类型',
						label: '其他类型'
					},
				],
				policy_stop_list: [{
						value: 1,
						label: '有'
					},
					{
						value: 0,
						label: '无'
					}
				],
				is_accumulation_list: [{
						value: 1,
						label: '有'
					},
					{
						value: 0,
						label: '无'
					},
					{
						value: -1,
						label: '未知'
					}
				],
				is_social_security_list: [{
						value: 1,
						label: '有'
					},
					{
						value: 0,
						label: '无'
					},
					{
						value: -1,
						label: '未知'
					}
				],
				income_type_list: [{
						value: 1,
						label: '银行代发(扣税)'
					},
					{
						value: 2,
						label: '银行转账'
					},
					{
						value: 3,
						label: '微信、支付宝或现金'
					},
					{
						value: 4,
						label: '股东分红或利润'
					},
					{
						value: 5,
						label: '其他'
					}
				],
				nowTime: '',
				//保单信息
				policy: {
					policy_name: '',
					policy_buy_time: '',
					total_due_periods: '',
					policy_people_name: '0',
					payment_type: '0',
					payment_payment_sum: '0',
					policy_type: '0',
					policy_stop: '0',
				},
				policyList: [],
				// 信用卡
				credit_card: {
					issuing_bank: '',
					issuing_bank_sum: '',
				},
				creditCardList: [],
				// 负债信息
				debt: {
					capital_name: '',
					loan_sum: '',
					borrower_period: '',
					loan_date: '',
				},
				debtList: [],
				introduceList: [],
				followLogList: [],
				commentLogList: [],
				contactLogList: [],
				distributionLogList: [],
				recordList: [],
				viewLogList: [],
				loanLogList: [],
				viewList: [],
				viewUpTime: 0,
				addContractShow: false,
				viewUpTimeList: [{
						value: 0,
						label: '快捷选择'
					},
					{
						value: 7,
						label: '1天后'
					},
					{
						value: 8,
						label: '2天后'
					},
					{
						value: 9,
						label: '3天后'
					},
					{
						value: 10,
						label: '4天后'
					},
					{
						value: 11,
						label: '5天后'
					},
					{
						value: 12,
						label: '6天后'
					},
					{
						value: 13,
						label: '7天后'
					},
				],
				followUpTime: 0,
				followUpTimeList: [{
						value: 0,
						label: '快捷选择'
					},
					{
						value: 1,
						label: '10分钟后'
					},
					{
						value: 2,
						label: '30分钟后'
					},
					{
						value: 3,
						label: '1小时后'
					},
					{
						value: 4,
						label: '2小时后'
					},
					{
						value: 5,
						label: '3小时后'
					},
					{
						value: 6,
						label: '5小时后'
					},
					{
						value: 7,
						label: '1天后'
					},
					{
						value: 8,
						label: '2天后'
					},
				],
				tagPoptip: false,

				tabsList: ['潜在需求', '否认申请', '异地申请', '不需要', '有逾期', '捣乱申请', '同行', '无条件', '查询超', '白户', '黑户'],
				quickList: ['开口挂', '关机', '停机', '需回拨', '不接', '空号', '忙线中', '挂断'],
				tab_list: [{
						show: true,
						name: '开口挂'
					},
					{
						show: true,
						name: '关机'
					},
					{
						show: true,
						name: '不接'
					}
				],
				phoneShow: false,
				nameShow: true,
				commentValue: '',
				follow: {
					door_time_date: '',
					door_time_hour: '',
					follow_time_date: '',
					follow_time_hour: '',
					remark: '',
				},
				stateList: [{
						value: 1,
						label: '未处理',
						is_true: 0
					},
					{
						value: 2,
						label: '待跟进',
						is_true: 0
					},
					{
						value: 3,
						label: '邀约中',
						is_true: 0
					},
					{
						value: 6,
						label: '上门未签约',
						is_true: 0
					},
					{
						value: 7,
						label: '已签约',
						is_true: 0
					},
					{
						value: 8,
						label: '进件中',
						is_true: 0
					},
					{
						value: 9,
						label: '银行拒绝',
						is_true: 0
					},
					{
						value: 13,
						label: '已回款',
						is_true: 0
					},
					{
						value: 14,
						label: '资质不符',
						is_true: 0
					},
					{
						value: 15,
						label: '捣乱申请',
						is_true: 0
					},
					{
						value: 16,
						label: '外地申请',
						is_true: 0
					},
					{
						value: 17,
						label: '重复申请',
						is_true: 0
					},
					{
						value: 18,
						label: '短信申请',
						is_true: 0
					}
				],
				introduceStatusList: [{
						value: 0,
						label: '无'
					},
					{
						value: 1,
						label: '开发拓客中'
					},
					{
						value: 2,
						label: '已转化寻找中'
					},
					{
						value: 3,
						label: '找不到'
					},
					{
						value: 4,
						label: '已转化待上门'
					},
					{
						value: 5,
						label: '已上门未能转化'
					},
					{
						value: 6,
						label: '已上门还可跟进'
					},
					{
						value: 7,
						label: '转化成功'
					}
				],
				rateList: [{
						value: 0,
						label: '0星'
					},
					{
						value: 1,
						label: '1星'
					},
					{
						value: 2,
						label: '2星'
					},
					{
						value: 3,
						label: '2星+'
					},
					{
						value: 4,
						label: '3星'
					},
					{
						value: 5,
						label: '4星'
					},
				],
				followList: [],
				items: [{
						name: 'apple',
						price: '5$'
					},
					{
						name: 'banana',
						price: "3$"
					},
					{
						name: 'pear',
						price: '4$'
					}
				],
				houseItems: [{
						name: 'house',
						value: 0,
						label: '无房'
					}, {
						name: 'house',
						value: 1,
						label: '本地房'
					},
					{
						name: 'house',
						value: 2,
						label: '月供房'
					},
				],
				policyShowList: [{
						value: 0,
						label: '无'
					}, {
						value: 1,
						label: '有'
					},

				],
				carItems: [{
						name: 'car',
						value: 0,
						label: '无车'
					}, {
						name: 'car',
						value: 1,
						label: '有车'
					},

				],
				creditCarItems: [{
						name: 'creditCard',
						value: 0,
						label: '无'
					}, {
						name: 'creditCard',
						value: 1,
						label: '有'
					},

				],
				weiliedaiItems: [{
						name: 'weilidai',
						value: 0,
						label: '无'
					}, {
						name: 'weilidai',
						value: 1,
						label: '有'
					},

				],
				company_main: [{
						name: 'company',
						value: 0,
						label: '无企税'
					}, {
						name: 'company',
						value: 1,
						label: '有企税'
					},

				],
				accumulation_fund_list: [{
						name: 'accumulation',
						value: 0,
						label: '无公积金'
					}, {
						name: 'accumulation',
						value: 1,
						label: '有公积金'
					},

				],
				social_security_list: [{
						name: 'social',
						value: 0,
						label: '无社保'
					}, {
						name: 'social',
						value: 1,
						label: '有社保'
					},

				],
				bussine_license: [{
						name: 'bussine',
						value: 0,
						label: '无执照'
					}, {
						name: 'bussine',
						value: 1,
						label: '有执照'
					},

				],
				salary_list: [{
						name: 'salary',
						value: 0,
						label: '无代发'
					}, {
						name: 'salary',
						value: 1,
						label: '有代发'
					},

				],
				isactive: -1,
				houseActive: -1,
				carActive: -1,
				accumulationActive: -1,
				salaryActive: -1,
				bussineActive: -1,
				companyActive: -1,
				socialActive: -1,

			}
		},
		methods: {
			...mapMutations([
				'setRemarksSaveStatus',
			]),
			...mapActions([
				'handleLogOut',
			]),
			handleClose(type, id) {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						client_id: that.client.id,
						type: type,
						tag: id
					};
					let res = await cancelTag(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.loadData()
					}
				}, 500)
			},
			    toggleWithLicense() {
			      this.withLicense = true;
			    },
			    toggleWithoutLicense() {
			      this.withLicense = false;
			    },
			async loadData() {
				let that = this;
				var date = new Date();
				this.nowTime = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
				if ((typeof that.id) == 'undefined') {
					return;
				}
				if (that.id != 0) {
					let data = {
						token: that.token,
						id: that.id,
						time: Date.parse(new Date())
					};
					let res = await getClient(that, data);
					if (res.code == 1) {
						that.client = res.data.item;
						that.firm = res.data.item.firm;
						that.policyList = res.data.policyList;
						that.creditCardList = res.data.creditCardList;
						that.debtList = res.data.debtList;
						that.introduceList = res.data.introduceList;
						that.introduceCount = res.data.introduceCount;
						that.followLogList = res.data.followLogList;
						that.commentLogList = res.data.commentLogList;
						that.contactLogList = res.data.contactLogList;
						that.viewLogList = res.data.viewLogList;
						that.viewList = res.data.viewList;
						that.loanLogList = res.data.loanLogList;
						that.distributionLogList = res.data.distributionLogList;
						that.recordList = res.data.recordList;
						that.tabsList = res.data.tabsList;
						that.followList = res.data.followList;
						that.client_message = res.data.info;
						that.client.new_phone = that.client.phone.substring(0, 3) + '****' + that.client.phone
							.substring(7, 11)
					}
				}
				//根据客户星级去做相应的状态选项disable
				this.startDisableStatus(this.client.start);
				this.introduceClientModal = false; //关闭拓客弹窗
				that.addContractShow = false;
				that.$emit('reloadData');
			},
			startDisableStatus(start) {
				/*
				stateList: [{
						value: 1,
						label: '未处理',
						is_true:1
					},
					{
						value: 2,
						label: '待跟进'
					},
					{
						value: 3,
						label: '邀约中'
					},
					{
						value: 6,
						label: '上门未签约'
					},
					{
						value: 7,
						label: '已签约'
					},
					{
						value: 8,
						label: '进件中'
					},
					{
						value: 9,
						label: '银行拒绝'
					},
					{
						value: 13,
						label: '已回款'
					},
					{
						value: 14,
						label: '资质不符'
					},
					{
						value: 15,
						label: '捣乱申请'
					},
					{
						value: 16,
						label: '外地申请'
					},
					{
						value: 17,
						label: '重复申请'
					},
					{
						value: 18,
						label: '短信申请'
					}
				],	*/
				if (start == 0) {
					this.stateList[0].is_true = 0;
					this.stateList[1].is_true = 0;
					this.stateList[2].is_true = 1;
					this.stateList[3].is_true = 1;
					this.stateList[4].is_true = 1;
					this.stateList[5].is_true = 1;
					this.stateList[6].is_true = 1;
					this.stateList[7].is_true = 1;
					this.stateList[8].is_true = 1;
					this.stateList[9].is_true = 1;
					this.stateList[10].is_true = 1;
					this.stateList[11].is_true = 1;
					this.stateList[12].is_true = 1;
				} else if (start == 1) {
					this.stateList[0].is_true = 1;
					this.stateList[1].is_true = 1;
					this.stateList[2].is_true = 1;
					this.stateList[3].is_true = 1;
					this.stateList[4].is_true = 1;
					this.stateList[5].is_true = 1;
					this.stateList[6].is_true = 1;
					this.stateList[7].is_true = 1;
					this.stateList[8].is_true = 0;
					this.stateList[9].is_true = 0;
					this.stateList[10].is_true = 0;
					this.stateList[11].is_true = 1;
					this.stateList[12].is_true = 1;
				} else {
					this.stateList[0].is_true = 1;
					this.stateList[1].is_true = 1;
					this.stateList[2].is_true = 0;
					this.stateList[3].is_true = 0;
					this.stateList[4].is_true = 0;
					this.stateList[5].is_true = 0;
					this.stateList[6].is_true = 0;
					this.stateList[7].is_true = 0;
					this.stateList[8].is_true = 1;
					this.stateList[9].is_true = 1;
					this.stateList[10].is_true = 1;
					this.stateList[11].is_true = 1;
					this.stateList[12].is_true = 0;
				}

			},
			statusClick(e) {
				let that = this;
				if (e.currentTarget.dataset.click_value == "house") {
					this.client.is_house = e.currentTarget.dataset.index_value
				}
				if (e.currentTarget.dataset.click_value == "car") {
					this.client.is_car = e.currentTarget.dataset.index_value
				}
				if (e.currentTarget.dataset.click_value == "company") {
					this.client.is_pay_taxes = e.currentTarget.dataset.index_value
				}
				if (e.currentTarget.dataset.click_value == "accumulation") {
					this.client.is_accumulation = e.currentTarget.dataset.index_value
				}
				if (e.currentTarget.dataset.click_value == "social") {
					this.client.is_social_security = e.currentTarget.dataset.index_value
				}
				if (e.currentTarget.dataset.click_value == "salary") {
					this.client.is_salary = e.currentTarget.dataset.index_value
				}
				if (e.currentTarget.dataset.click_value == "weilidai") {
					this.client.is_weilidai = e.currentTarget.dataset.index_value
				}
				if (e.currentTarget.dataset.click_value == "creditCard") {
					this.client.is_credit_card = e.currentTarget.dataset.index_value
				}

				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.client
					};
					let res = await saveClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						if (that.id == 0) {
							that.id = res.data.id;
						}
						that.loadData();
					}
				}, 500)
			},
			invateDayChange(e) {
				this.invateDoor.invate_day = e;
			},
			//保存拓客状态
			saveIntroduceStatus(e) {
				let that = this;
				that.introduceClient = e;
				that.introduceClient.client_id = that.id;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.introduceClient
					};
					let res = await saveIntroduceClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.loadData();
						that.$emit('reloadData');
					}
				}, 500)
			},
			eraseFollow(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认撤销吗？',
					onOk: async () => {
						let res = await eraseFollow(that, {
							token: that.token,
							id: id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.loadData();
						}
					}
				})
			},
			//新增拓客
			saveIntroduceClient(e) {
				let that = this;
				that.introduceClient.client_id = that.id;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.introduceClient,
					};
					let res = await saveIntroduceClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.loadData();
						that.$emit('reloadData');
					}
				}, 500)
			},
			introduceInit() {
				this.introduceClient = {
					introduce_name: '',
					introduce_phone: '',
					introduce_sex: '',
					introduce_status: '',
					introduce_message: '',
				};
			},
			addRemark(e) {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						client_id: that.client.id,
						remark: that.remarkValue
					};
					let res = await addRemark(that, data);
					if (res.code == 1) {
						that.remarkValue = '';
						that.$Message.success(res.msg);
						this.setRemarksSaveStatus(Date.parse(new Date()))
						that.loadData();
					}
				}, 500)
			},
			saveClient() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.client
					};
					data.data.firm = that.firm;
					let res = await saveClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.loadData();
						that.clientType = 9;
					}
				}, 500)
			},
			addToMyClient() {
				let that = this;
				let id = that.client.id;
				this.$Modal.confirm({
					title: '确认转为我的客户吗？',
					onOk: async () => {
						let res = await addToMyClient(that, {
							token: that.token,
							id: id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.loadData();
							that.$emit('reloadData');
						}
					}
				})
			},
			addPool() {
				let that = this;
				let id = that.client.id;
				this.$Modal.confirm({
					title: '确认加入公共池吗？',
					onOk: async () => {
						let res = await addPool(that, {
							token: that.token,
							id: id
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.loadData();
							that.$emit('reloadData');
						}
					}
				})
			},
			saveClientStatus() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.client
					};
					data.data.firm = that.firm;
					let res = await saveClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
					}
				}, 500)
			},
			saveClient() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.client
					};
					data.data.firm = that.firm;
					let res = await saveClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.loadData();
						this.clientType = 9;
						that.$emit('reloadData');
					}
				}, 500)
			},
			addClientTag(e) {
				let that = this;
				let id = parseInt(e.currentTarget.dataset.key) + 1;
				this.throttle(async function() {
					let data = {
						token: that.token,
						client_id: that.client.id,
						tag: id
					};
					let res = await addClientTag(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.tagPoptip = false;
						that.$emit('reloadData');
					}
				}, 500)
			},
			changeMenu(name) {

				if (name == 'invate_door') {
					this.invateDoorModal = true

				} else if (name == 'invate_introduce') {
					//设置后台请求地址
					var name = "严松云";
					var address = "南丰创荟";
					const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
					window.open(baseUrl + '/app/task/invate_door?name=' + name + '&address=' + address);

				}
			},
			saveInvateDoor() {
				let that = this;
				var invateDoor = that.invateDoor
				this.$Modal.confirm({
					title: '确认生成邀约上门名片吗？',
					onOk: async () => {
						const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config
							.baseUrl.pro
						window.open(baseUrl + '/app/task/invate_door?invate_name=' + invateDoor.invate_name +
							'&invate_money=' + invateDoor.invate_money + '&invate_day=' + invateDoor
							.invate_day + '&invate_address=' + invateDoor.invate_address +
							'&invate_data=' + invateDoor.invate_data);
					}
				})
			},
			addContactTag(e) {
				let that = this;
				let id = parseInt(e.currentTarget.dataset.key) + 1;
				this.throttle(async function() {
					let data = {
						token: that.token,
						client_id: that.client.id,
						tag: id
					};
					let res = await addContactTag(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.$emit('reloadData');
					}
				}, 500)
			},
			async lock() {
				let that = this;
				let id = that.client.id;
				let res = await lock(that, {
					token: that.token,
					id: id
				});
				if (res.code == 1) {
					that.$Message.success(res.msg);
					that.loadData();
				}
			},
			save() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.client
					};
					data.data.firm = that.firm;
					let res = await saveClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						if (that.id == 0) {
							that.id = res.data.id;
						}
						that.loadData();
					}
				}, 500)
			},
			makeTimeChange(e) {
				this.viewed_at = e
			},
			async addEmergency(e) {
				let that = this;
				let val = e.currentTarget.dataset.val;
				let res = await addEmergencyTag(that, {
					token: that.token,
					id: that.client.id,
					val: val
				});
				if (res.code == 1) {
					that.$Message.success(res.msg);
					that.$emit('reloadData');
				}
			},
			async changeViewUpTime(e) {
				let res = await getTimeLater(this, {
					token: this.token,
					type: e
				});
				if (res.code == 1) {
					this.follow.door_time_date = res.data.date;
					this.follow.door_time_hour = res.data.time;
				}
			},
			saveIsCloseStatus(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.throttle(async function() {
					let res = await saveIsCloseStatus(that, {
						token: that.token,
						id: id
					});
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.loadData();
					}
				}, 500)
			},
			saveFollow(e) {
				let that = this;
				let type = e;
				console.log(type)
				this.throttle(async function() {
					let data = {
						token: that.token,
						client_id: that.client.id,
						data: that.follow,
						type: type
					};
					let res = await saveFollow(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.follow.door_time_date = '';
						that.follow.door_time_hour = '';
						that.follow.follow_time_date = '';
						that.follow.follow_time_hour = '';
						that.follow.remark = '';
						that.loadData();
					}
				}, 500)
			},
			callMobile() {
				let that = this;
				let phone = that.client.phone;
				let client_id = that.client.id;
				this.$Modal.confirm({
					title: '确认要拨打电话吗？',
					onOk: async () => {
						let res = await sendOrderNoticeNew(that, {
							token: that.token,
							phone: phone,
							client_id: client_id,
						});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.loadData();
							that.$emit('reloadData');
						}
					}
				})
			},
			handleTabClose(index) {
				this.tab_list[index].show = false
			},
			async changeFollowUpTime(e) {
				let res = await getTimeLater(this, {
					token: this.token,
					type: e
				});
				if (res.code == 1) {
					this.follow.follow_time_date = res.data.date;
					this.follow.follow_time_hour = res.data.time;
				}
			},
			savePolicy() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.policy,
						client_id: that.id
					};
					let res = await savePolicy(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.policy = {
							policy_name: '',
							policy_buy_time: '',
							total_due_periods: '',
							policy_people_name: '0',
							payment_type: '0',
							payment_payment_sum: '0',
							policy_type: '0',
							policy_stop: '0',
						};
						that.loadData();
					}
				}, 500)
			},
			saveCreditCard() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.credit_card,
						client_id: that.id
					};
					let res = await saveCreditCard(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.credit_card = {
							issuing_bank: '',
							issuing_bank_sum: '',
						};
						that.loadData();
					}
				}, 500)
			},
			saveDebt() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						data: that.debt,
						client_id: that.id
					};
					let res = await saveDebt(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.debt = {
							capital_name: '',
							loan_sum: '',
							borrower_period: '',
							loan_date: '',
						};
						that.loadData();
					}
				}, 500)
			},
			saveComment() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						remark: that.commentValue,
						client_id: that.id
					};
					let res = await saveComment(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.commentValue = '';
						that.loadData();
					}
				}, 500)
			},
			changeClientType(e) {
				this.clientType = e.currentTarget.dataset.type;
			},
			clickPhoneShow() {
				let that = this;
				if (this.phoneShow == true) {
					this.phoneShow = false;
				} else {
					this.phoneShow = true;
				}
				this.throttle(async function() {
					let data = {
						token: that.token,
						client_id: that.id
					};
					let res = await lookPhone(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
					}
				}, 500)

			},
			changeTabType(e) {

				this.tabType = e.currentTarget.dataset.type;
			},
			addVisit() {
				let that = this;
				this.throttle(async function() {
					let data = {
						token: that.token,
						viewed_at: that.viewed_at,
						visit_id: that.id,
						status: that.status
					};
					let res = await addVisit(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.addVisitModal = false;
						that.loadData();
					}
				}, 500)
			},
			beforeOne() {
				/*
				let that = this;
				this.$nextTick(() => {
					that.$emit('beforeOne');
				})
				*/
				let that = this;
				that.phoneShow = false;
				let item = that.findBeforeArr(that.$route.params.data, 'id', that.id);
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				this.$router.push({
					name: 'newEditClue',
					params: {
						id: item.id,
						name: item.name,
						data: that.$route.params.data
					},
				})
				//that.id = item.id;

			},
			nextOne() {
				/*
				let that = this;
				this.$nextTick(() => {
					that.$emit('nextOne');
				})
				*/
			   
				let that = this;
				that.phoneShow = false;
				let item = that.findNextArr(that.$route.params.data, 'id', that.id);
				if (item == false) {
					that.$Message.error('此页没有更多了');
					return;
				}
				this.$router.push({
					name: 'newEditClue',
					params: {
						id: item.id,
						name: item.name,
						data: that.$route.params.data
					},
				})
				
				//that.id = item.id;
			},
			timestampToTime(timestamp) {
				var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
				var Y = date.getFullYear() + '-';
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				var D = date.getDate() + ' ';
				var h = date.getHours() + ':';
				var m = date.getMinutes() + ':';
				var s = date.getSeconds();
				return Y + M + D + h + m + s;
			}
		},
		filters: {}
	}
</script>
<style scoped lang="less">
	/deep/ input[disabled],
	input:disabled,
	input.disabled {
		-webkit-text-fill-color: #333;
		-webkit-opacity: 1;
		opacity: 1;
	}

	.clientType {
		font-size: 16px;
		color: black;
		padding: 10px 0px;
		position: absolute;

		span {
			padding: 10px 20px;
		}

		.active {
			font-weight: bold;
			color: #2A8BF6;
			padding: 10px 20px;
			border-bottom: 4px solid #2A8BF6;
		}
	}
.license-toggle {
  display: inline-block;
  padding: 5px 10px;
  border: 1px solid #ccc;
  cursor: pointer;
}

.license-toggle.active {
  background-color: blue;
  color: #fff;
}
	ul li.active {
		background: #277dd3;
		color: #fff;
	}

	.statusbtn {
		color: #d6caca;
		cursor: not-allowed;
		/*这个在button上面才管用,是一个禁用的小标识*/
	}
</style>